export default __webpack_public_path__ + "alarmStatus-armed-away.4989419c.png";